var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Pen = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 768 741.49", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M758.63 78.86l-50.75-50.74a96 96 0 0 0-135.76 0L169.37 430.86a32 32 0 0 0 0 45.26l96 96a32 32 0 0 0 45.26 0l384-384a32 32 0 0 0-45.26-45.26L288 504.24l-50.74-50.75L617.37 73.37a32 32 0 0 1 45.26 0l50.74 50.75a32 32 0 0 0 45.26-45.26zM150.63 494.86a32 32 0 0 0-51.25 8.32l-96 192a32 32 0 0 0 42.93 42.93l192-96a32 32 0 0 0 8.32-51.25zm-47.07 143.08l33.21-66.43L170 604.72z" }))))); };
export default Pen;
//# sourceMappingURL=Pen.js.map